import React from 'react'
import PropTypes from 'prop-types'
import FormRow from './FormRow'


class OrderForm extends React.Component {

    constructor(props) {
        super(props)
        this.firstInput = React.createRef();
    }

    componentDidMount() {
        setTimeout(() => this.firstInput.current.focusTextInput(), 200);
    }

    render() {
        return (
            <form onSubmit={(e) => {
                e.preventDefault();
                this.props.onSubmit();
                this.props.history.push('/orders');
            }}>
            <div className="container-fluid">
                <div className="alert alert-info d-md-none">
                    Bestel eenvoudig glas, roosters en draairamen voor renovatiewerk. Geef de <strong>exacte sponningmaten</strong> in mm, en de juiste maten worden automatisch berekend.
                </div>

                <div className="form-row mb-2 align-items-end d-none d-md-flex">
                    <div className="col-md-2">
                        <div className="form-row">
                            <div className="col-sm-2 text-muted">

                            </div>
                            <div className="col-sm-10">
                               Positie
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-row mb-1">
                            <div className="col text-muted">
                                <i>Exacte sponningmaten in mm</i>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col">
                                Breedte
                            </div>
                            <div className="col">
                                Hoogte
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1">
                        Aantal
                    </div>
                    <div className="col-md-1">
                        Type
                    </div>
                    <div className="col-md-2">
                        Glas
                    </div>
                    <div className="col-md-2">
                        Rooster
                    </div>
                    <div className="col-md-1">

                        <div className="form-row">
                            <div className="col text-center">
                                m<sup>2</sup>
                            </div>
                            <div className="col">

                            </div>
                        </div>
                    </div>


                </div>

                { this.props.rows.map((row, index) => (
                    <FormRow
                        ref={index === 0 ? this.firstInput : null }
                        key={index}
                        nr={index}
                        type={row.type}
                        glass={row.glass}
                        height={row.height}
                        width={row.width}
                        number={row.number}
                        ventilation={row.ventilation}
                        onChange={(name, value) => this.props.onRowChange(index, name, value)} />
                ))}

                <div className="modal fade" id="modalCorrections" tabIndex="-1" role="dialog" aria-labelledby="modalCorrections" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Maatcorrecties</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="form-group">
                                    <label>Breedte correctie glas</label>
                                    <input type="number" className="form-control" name="glass_width_correction" value={this.props.glass_width_correction} onChange={(event) => this.props.onCorrectionChange(event.target.name, event.target.value)}/>
                                        <small className="form-text text-muted">Breedte correctie bij glasbestelling</small>
                                </div>

                                <div className="form-group">
                                    <label>Hoogte correctie glas</label>
                                    <input type="number" className="form-control" name="glass_height_correction" value={this.props.glass_height_correction} onChange={(event) => this.props.onCorrectionChange(event.target.name, event.target.value)}/>
                                    <small className="form-text text-muted">Hoogte correctie bij glasbestelling</small>
                                </div>

                                <div className="form-group">
                                    <label>Breedte correctie bij raam</label>
                                    <input type="number" className="form-control" name="glass_width_correction_window" value={this.props.glass_width_correction_window} onChange={(event) => this.props.onCorrectionChange(event.target.name, event.target.value)}/>
                                    <small className="form-text text-muted">Breedte correctie voor glas bij raambestelling</small>
                                </div>

                                <div className="form-group">
                                    <label>Hoogte correctie bij raam</label>
                                    <input type="number" className="form-control" name="glass_height_correction_window" value={this.props.glass_height_correction_window} onChange={(event) => this.props.onCorrectionChange(event.target.name, event.target.value)}/>
                                    <small className="form-text text-muted">Hoogte correctie voor glas bij raambestelling</small>
                                </div>

                                <div className="form-group">
                                    <label>Breedte correctie bij raam</label>
                                    <input type="number" className="form-control" name="window_width_correction" value={this.props.window_width_correction} onChange={(event) => this.props.onCorrectionChange(event.target.name, event.target.value)}/>
                                    <small className="form-text text-muted">Breedte correctie voor raam bij raambestelling</small>
                                </div>
                                <div className="form-group">
                                    <label>Hoogte correctie bij raam</label>
                                    <input type="number" className="form-control" name="window_height_correction" value={this.props.window_height_correction} onChange={(event) => this.props.onCorrectionChange(event.target.name, event.target.value)}/>
                                    <small className="form-text text-muted">Hoogte correctie voor raam bij raambestelling</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row d-md-block d-none">
                    <div className="col text-right">
                        <div className="btn-group">
                            <button className="btn btn-secondary" data-toggle="modal" data-target="#modalCorrections" type="button"><i className="fas fa-wrench"/></button>
                            <button className="btn btn-secondary" onClick={this.props.addRow} type="button">
                                <i className="fas fa-plus"/>
                            </button>
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col text-center">
                        <div className="btn-group">
                            <button className="btn btn-secondary d-md-none" data-toggle="modal" data-target="#modalCorrections" type="button"><i className="fas fa-wrench"/></button>
                            <button className="btn btn-secondary d-md-none" onClick={this.props.addRow} type="button">
                                <i className="fas fa-plus"/>
                            </button>
                            <button className="btn btn-primary btn-lg hvr-icon-push" type="submit"><i className="fas fa-check hvr-icon"/> <span className="d-md-none">Bestellen</span> <span className="d-none d-md-inline">Controleren en bestellen</span></button>
                        </div>
                    </div>
                </div>


            </div>
            </form>
        )
    }
}

OrderForm.propTypes = {
    addRow: PropTypes.func.isRequired,
    onRowChange: PropTypes.func.isRequired,
    onCorrectionChange: PropTypes.func.isRequired,
    rows: PropTypes.array.isRequired,
}

export default OrderForm


// WEBPACK FOOTER //
// ./src/components/OrderForm.js